import { extendTailwindMerge } from "tailwind-merge";

// Docs: https://github.com/dcastil/tailwind-merge/blob/v1.14.0/docs/configuration.md#usage-with-custom-tailwind-config
export const twMerge = extendTailwindMerge({
	prefix: "tw-",
});
